const QUOTE_ASSET_SEARCH_PATTERN = /^q[\d-]*$/;
const NUMERIC_ASSET_SEARCH_INPUT_PATTERN = /^\d*$/;
const NUMERIC_ASSET_SEARCH_PATTERN = /^\d+$/;

export const isValidAssetSearchInput = (value: string) => {
    if (value.length === 0) {
        return true;
    }

    const normalizedValue = value.toLowerCase();

    if (normalizedValue.startsWith('q')) {
        return QUOTE_ASSET_SEARCH_PATTERN.test(normalizedValue);
    }

    return NUMERIC_ASSET_SEARCH_INPUT_PATTERN.test(value);
};

export const isValidAssetSearchFilter = (value: string | null) => {
    if (!value) {
        return false;
    }

    const normalizedValue = value.toLowerCase();

    if (normalizedValue.startsWith('q')) {
        return QUOTE_ASSET_SEARCH_PATTERN.test(normalizedValue);
    }

    return NUMERIC_ASSET_SEARCH_PATTERN.test(value);
};
